<template>
  <el-container class="analysisAndJudgmentWQ">
    <el-card class="tabs-card">
      <el-form
        :inline="true"
        ref="formRef"
        :model="tableParams"
        class="demo-form-inline"
      >
        <el-form-item label="所属单位" prop="search">
          <h-selectcode
            type="unitType"
            v-model="tableParams.search"
            placeholder="所属单位"
            :clearable="true"
          ></h-selectcode>
        </el-form-item>
        <el-form-item label="名称" prop="regionId">
          <h-selectcode
            type="economicType"
            v-model="tableParams.regionId"
            placeholder="名称"
            :clearable="true"
          ></h-selectcode>
        </el-form-item>
        <el-form-item>
          <h-button type="primary" @click="refreshTable()">查询</h-button>
          <h-button @click="resetForm(formRef)">重置</h-button>
        </el-form-item>
        <el-row>
          <el-col>
            <h-button type="primary" @click="addButton">添加</h-button>
            <h-button type="danger" @click="delUser">删除</h-button>
            <!-- <h-button type="primary">导入</h-button>
            <h-button type="primary">导出</h-button> -->
          </el-col>
        </el-row>
      </el-form>
      <div class="table-box">
        <h-table
          ref="tableRef"
          v-model:data="tableData"
          v-model:columns="columns"
          :method="unitList"
          :params="tableParams"
          @handleClick="handleClick"
          @select="hzTableSelect"
        >
          <template #imageUrl="{ row }">
            <!-- <span v-if="row.imageUrl && row.imageUrl.indexOf('http') == -1">{{
              "暂无"
            }}</span> -->
            <img :src="imgURL + row.imageUrl || imgMoren" />
          </template>
          <template #unitName="{ row }">
            <div class="table-role" @click="clickTable(row)">
              <span>{{ row.unitName }}</span>
            </div>
          </template>
        </h-table>
      </div>
    </el-card>
    <unitl-components
      v-model="formVisible"
      :form="userFormData"
      :status="formStatus"
      @submit="userSubmit"
    ></unitl-components>
    <!--  -->

    <!--  -->
  </el-container>
</template>
<script>
import { defineComponent, nextTick, reactive, toRefs, ref } from "vue";
import { ElMessageBox, ElMessage } from "element-plus";

import { unitdelete } from "@/api/management/management";
import { getMenutree } from "@/api/system/region.js";
import _ from "lodash";
export default defineComponent({
  name: "analysisAndJudgmentWQ",
  components: {},
  props: {},
  setup(props) {
    const state = reactive({
      imgURL: window.imgURL,
      imgMoren: require("@/assets/images/moren.png"),
      filterText: "",
      tableSelection: [],
      rootNodeKey: "",
      treeCard: {
        height: "100%",
        display: "flex",
        flexDirection: "column",
      },
      dataSource: [],
      userFormData: {},
      tableParams: {
        xm: "",
        xb: "",
        zjhm: "",
        mz: "",
        sjh: "",
        dh: "",
        nl: "",
      },
      tableData: [],
      formStatus: 1, // 1 添加  2 编辑
      formVisible: false,
      // 图片、类型、名称、数量、单位、所属单位、负责人、负责人联系方式
      columns: [
        { type: "selection" },
        {
          label: "照片",
          slot: "imageUrl",
        },
        {
          label: "类型",
          slot: "unitName",
        },
        {
          label: "名称",
          prop: "dz",
        },
        {
          label: "数量",
          prop: "legalName",
        },
        {
          label: "单位",
          prop: "dw",
        },
        {
          label: "所属单位",
          prop: "ssdw",
        },
        {
          label: "负责人",
          prop: "fzr",
        },
        {
          label: "负责人联系方式",
          prop: "fzrdh",
        },
        {
          type: "operate",
          label: "操作",
          width: "140px",
          operates: [
            { name: "编辑", emitKey: "edit" },
            { name: "删除", emitKey: "del", type: "danger" },
          ],
        },
      ],
    });
    const refData = toRefs(state);
    // const treeRef = ref(null);
    const tableRef = ref(null);
    const formRef = ref(null);
    // 对组织树节点进行筛选时执行的方法
    const filterNode = (value, data, node) => {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    };
    // 当前选中节点变化时触发的事件
    const currentChange = (item, nodes) => {
      state.currentNode = item;
      state.tableParams.deptId = item.deptId;
      state.userFormData.parentId = item.deptId;
      nextTick(() => {
        tableRef.value && tableRef.value.refresh();
      });
    };
    // 获取结构树
    const queryOrganTreAsync = async () => {
      const result = await getMenutree();
      const treeData = [result.data];
      state.dataSource = treeData;
      if (treeData[0]) {
        currentChange(treeData[0]);
        nextTick(() => {
          state.rootNodeKey = state.currentNode.id;
          // treeRef.value.setCurrentKey(state.currentNode.deptId);
        });
        state.rootNodeKey = treeData[0].children[0].id;
      }
    };
    queryOrganTreAsync();
    // 点击查询按钮
    const refreshTable = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 重置表单
    const resetForm = (formEl) => {
      if (!formEl) return;
      formEl.resetFields();
    };
    // 表单提交
    const userSubmit = () => {
      tableRef.value && tableRef.value.refresh();
    };
    // 点击table操作按钮
    const handleClick = (operate, row) => {
      const { emitKey } = operate;
      if (emitKey === "edit") {
        // 编辑
        state.formStatus = 2; // 把表单设置为编辑状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
        nextTick(() => {});
      } else if (emitKey === "info") {
        // 详情
        state.formStatus = 3; // 把表单设置为查看状态
        state.userFormData = _.cloneDeep(row);
        state.formVisible = true;
      } else if (emitKey === "del") {
        ElMessageBox.confirm("您确认要删除该单位吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            deleteUserAsync([row.regionId]);
          },
          () => {}
        );
      }
    };
    // 当用户手动勾选数据行的 Checkbox 时触发的事件
    const hzTableSelect = (selection) => {
      state.tableSelection = selection;
    };
    // 点击添加按钮
    const addButton = () => {
      state.userFormData = {};
      state.formStatus = 1;
      state.formVisible = true;
    };
    const deleteUserAsync = async (ids) => {
      const res = await unitdelete(ids);
      if (res.code === 0) {
        refreshTable();
        ElMessage({
          type: "success",
          message: "删除成功",
        });
      }
    };
    // 批量删除用户
    const delUser = () => {
      if (state.tableSelection.length > 0) {
        ElMessageBox.confirm("您确认要删除选择的单位吗？", "删除", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(
          () => {
            const ids = state.tableSelection.map((item) => item.regionId);
            deleteUserAsync(ids);
            state.tableSelection = [];
          },
          () => {}
        );
      } else {
        ElMessage({
          type: "warning",
          message: "请选择要删除的单位",
        });
      }
    };
    const clickTable = async (item) => {
      state.userFormData = _.cloneDeep(item);
      state.formStatus = 3;
      state.formVisible = true;
    };
    const unitList = async (item) => {
      return {
        page: {
          list: [
            {
              imageUrl: require("./ybzxwp.png"),
              unitName: "易爆炸性物品",
              dz: "烟花",
              legalName: "115",
              dw: "个",
              ssdw: "重庆市开州区鸿鑫烟花爆竹有限公司",
              fzr: "刘稳",
              fzrdh: "18563544436",
            },
            {
              imageUrl: require("./yb.png"),
              unitName: "易爆炸性物品",
              dz: "煤气罐",
              legalName: "60",
              dw: "个",
              ssdw: "重庆市开州区燃气有限责任公司",
              fzr: "王小平",
              fzrdh: "17689785546",
            },
          ],
          totalCount: 2,
        },
      };
    };
    return {
      ...refData,
      clickTable,
      filterNode,
      currentChange,
      addButton,
      refreshTable,
      resetForm,
      delUser,
      hzTableSelect,
      handleClick,
      userSubmit,
      unitList,
      formRef,
      tableRef,
    };
  },
});
</script>
<style lang="scss" scoped>
.analysisAndJudgmentWQ {
  .tree-card {
    height: 100%;
    width: 300px;
    .input-with-select {
      margin-bottom: 10px;
    }
    .tree-box {
      flex: 1;
      overflow: auto;
      position: relative;
      .tree-header {
        position: sticky;
        top: 0;
        z-index: 2;
        padding: 10px 0;
        background-color: var(--el-color-white);
        color: var(--el-text-color-regular);
        @include flex-row-sb-c;
        .tree-name {
          flex: 1;
          margin-right: 10px;
          padding-left: 48px;
        }
        .tree-status {
          width: 50px;
        }
      }
    }
  }
  .tabs-card {
    flex: 1;
    margin-left: 10px;
    .tabs-tabel-box {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .table-box {
      flex: 1;
      overflow: hidden;
      img {
        width: 42%;
        height: 90px;
      }
      .table-role {
        color: #294a7c;
        cursor: pointer;
        span {
          border-bottom: 1px solid;
        }
      }
    }
  }
}
</style>
